import React, { useEffect, useState } from 'react';
import './Footer.css';
import { withRouter } from 'react-router-dom';
import { RoutePaths } from '../../Constants';

const Footer = ({ history }) => {
  useEffect(() => {
    history.location.pathname.toLowerCase() ===
    RoutePaths.MyAccount.toLowerCase()
      ? setShowTermsOfUse(true)
      : setShowTermsOfUse(false);
  }, [history.location.pathname]);

  const [showTermsOfUse, setShowTermsOfUse] = useState(false);

  const FooterLinks = () => (
    <span className="footer-link-container">
      <a
        href="https://lntermsandconditions.blob.core.windows.net/tnc/faq.html"
        className="link"
        target="_blank"
        rel="noopener noreferrer"
      >
        FAQs
      </a>
      {showTermsOfUse ? (
        <>
          <span>|</span>
          <a
            href="https://lntermsandconditions.blob.core.windows.net/tnc/tnc.html"
            className="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use
          </a>
          |
          <a
            href="https://lntermsandconditions.blob.core.windows.net/tnc/privacypolicy.html"
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            Privacy Policy
          </a>
        </>
      ) : null}
    </span>
  );

  return (
    <div id="footer" className="app-footer">
      <div className="row">
        <div className="col-md-12">
          <div className="copyrights">
            <span>© 2019 LogisticsNow. All Rights Reserved.</span>
            <FooterLinks />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Footer);
